var map = {
	"./en-us.js": [
		"./src/locale/lang/en-us.js",
		58
	],
	"./en-us/desc.js": [
		"./src/locale/lang/en-us/desc.js",
		62
	],
	"./en-us/menu.js": [
		"./src/locale/lang/en-us/menu.js",
		63
	],
	"./zh-cn.js": [
		"./src/locale/lang/zh-cn.js",
		34
	],
	"./zh-cn/desc.js": [
		"./src/locale/lang/zh-cn/desc.js",
		64
	],
	"./zh-cn/menu.js": [
		"./src/locale/lang/zh-cn/menu.js",
		65
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/locale/lang lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;